import { render, staticRenderFns } from "./SurveyQuestions.vue?vue&type=template&id=5de60ed2&scoped=true"
import script from "./SurveyQuestions.vue?vue&type=script&lang=js"
export * from "./SurveyQuestions.vue?vue&type=script&lang=js"
import style0 from "./SurveyQuestions.vue?vue&type=style&index=0&id=5de60ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de60ed2",
  null
  
)

export default component.exports